import React, { useEffect } from "react"
import styled from "styled-components"
import Page1Table from "./Page1Table"

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`

const PageArrowWrapper = styled.div`
  display: flex;
  width: 96px;
  height: 136px;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  flex: 1 0 0;
  align-self: stretch;
`

const Frame = styled.div`
  display: flex;
  width: 480px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 32px;
  flex-wrap: wrap;
`

const Before = styled.div`
  display: flex;
  width: 224px;
  height: 248px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  position: relative; /* 부모 기준으로 absolute 설정 */
`

const Board = styled.div`
  display: flex;
  height: 200px;
  padding-bottom: 20px;
  justify-content: center;
  align-items: flex-end;
  gap: 32px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 16px;
  background: var(--base-white100, #fff);
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1); /* 그림자 추가 */
`

const Badge = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  justify-content: center;
  align-items: center;
  position: absolute; /* Before 기준으로 위치 설정 */
  top: -15px; /* 위치 조정 */
  left: 50%; /* 수평 중앙 정렬 */
  transform: translateX(-50%); /* 수평 중앙 보정 */
  border-radius: 99px;
  background: var(--primary70, #3957d3);

  color: var(--base-white100, #fff);
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const BoardGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

const BoadItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  color: var(--base-gray100, #262626);
  text-align: center;
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const Title = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;

  border-radius: 99px;
  background: var(--secondary20, #e3e9f7);

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

const Frame2 = styled.div`
  display: flex;
  width: 656px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`

const Header = styled.div`
  display: flex;
  padding: 32px 0px;
  justify-content: center;
  align-items: flex-start;
  gap: 28px;
  align-self: stretch;

  border-radius: 16px;
  background: var(--secondary10, #eef1f9);
`

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: var(--primary90, #253c64);
  font-family: SUIT;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const HeaderContent = styled.div`
  display: flex;
  padding-top: 4px;
  align-items: center;
`

const HeaderContentGrid = styled.div`
  display: flex;
  width: 160px;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
`

const Unit3 = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

const Unit3Title = styled.div`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 99px;
  background: var(--secondary30, #dce3f5);

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const Table = styled.div`
  display: flex;
  height: 296px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--base-gray20, #dedede);
  background: var(--base-white50, rgba(255, 255, 255, 0.5));
`

interface Props {
  대전Data: any
  보령Data: any
  여수Data: any
  정읍Data?: any
}

const Page1 = (props: Props) => {
  const { 대전Data, 보령Data, 여수Data, 정읍Data } = props

  return (
    <Wrapper>
      <PageArrowWrapper></PageArrowWrapper>
      <Content>
        <Frame>
          <Before>
            <Board>
              <BoardGrid>
                <BoadItem>
                  <Title>자립률</Title>
                  {Number(정읍Data?.substitutionRate) || 0} %
                </BoadItem>
                <BoadItem>
                  <Title>전기요금</Title>
                  {Number((정읍Data?.usgChargeSum / 10000)?.toFixed(0)) ||
                    0?.toLocaleString()}{" "}
                  만원
                </BoadItem>
              </BoardGrid>
              <BoardGrid>
                <BoadItem>
                  <Title>발전량</Title>
                  {Number(
                    정읍Data?.genSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
                <BoadItem>
                  <Title>소비량</Title>
                  {Number(
                    정읍Data?.usgSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
              </BoardGrid>
            </Board>
            <Badge>정읍</Badge>
          </Before>
          <Before>
            <Board>
              <BoardGrid>
                <BoadItem>
                  <Title>자립률</Title>
                  {대전Data?.substitutionRate} %
                </BoadItem>
                <BoadItem>
                  <Title>전기요금</Title>
                  {Number(
                    (대전Data?.usgChargeSum / 10000)?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  만원
                </BoadItem>
              </BoardGrid>
              <BoardGrid>
                <BoadItem>
                  <Title>발전량</Title>
                  {Number(
                    대전Data?.genSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
                <BoadItem>
                  <Title>소비량</Title>
                  {Number(
                    대전Data?.usgSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
              </BoardGrid>
            </Board>
            <Badge>대전</Badge>
          </Before>
          <Before>
            <Board>
              <BoardGrid>
                <BoadItem>
                  <Title>자립률</Title>
                  {Number(보령Data?.substitutionRate)} %
                </BoadItem>
                <BoadItem>
                  <Title>전기요금</Title>
                  {Number(
                    (보령Data?.usgChargeSum / 10000)?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  만원
                </BoadItem>
              </BoardGrid>
              <BoardGrid>
                <BoadItem>
                  <Title>발전량</Title>
                  {Number(
                    보령Data?.genSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
                <BoadItem>
                  <Title>소비량</Title>
                  {Number(
                    보령Data?.usgSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
              </BoardGrid>
            </Board>
            <Badge>보령</Badge>
          </Before>
          <Before>
            <Board>
              <BoardGrid>
                <BoadItem>
                  <Title>자립률</Title>
                  {Number(여수Data?.substitutionRate)} %
                </BoadItem>
                <BoadItem>
                  <Title>전기요금</Title>
                  {Number(
                    (여수Data?.usgChargeSum / 10000)?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  만원
                </BoadItem>
              </BoardGrid>
              <BoardGrid>
                <BoadItem>
                  <Title>발전량</Title>
                  {Number(
                    여수Data?.genSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
                <BoadItem>
                  <Title>소비량</Title>
                  {Number(
                    여수Data?.usgSum?.toFixed(0) || 0
                  )?.toLocaleString()}{" "}
                  MWh
                </BoadItem>
              </BoardGrid>
            </Board>
            <Badge>여수</Badge>
          </Before>
        </Frame>
        <Frame2>
          <Header>
            <HeaderTitle>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="35"
                viewBox="0 0 25 35"
                fill="none"
              >
                <path
                  d="M10.8044 1.15723H14.2698L16.5423 8.75902V24.9446L18.5923 31.8259H23.623V34.2853L1.22705 34.0992V31.9748L6.33214 31.9375L8.64272 24.9446L8.56827 9.09404L10.8044 1.15723Z"
                  fill="#99A4AC"
                />
                <path
                  d="M22.508 10.5796H20.5581V12.65H22.508V10.5796Z"
                  fill="#D9F2F2"
                />
                <path
                  d="M4.45914 10.5796H2.50928V12.65H4.45914V10.5796Z"
                  fill="#D9F2F2"
                />
                <path
                  d="M4.45914 18.646H2.50928V20.7164H4.45914V18.646Z"
                  fill="#D9F2F2"
                />
                <path
                  d="M22.508 18.5317H20.5581V20.6021H22.508V18.5317Z"
                  fill="#D9F2F2"
                />
                <path
                  d="M1.08793 34.4982C0.88851 34.4459 0.781267 34.2669 0.753792 34.0028C0.705932 33.5419 0.693524 32.2559 0.75911 31.8145C0.795448 31.5672 1.00107 31.3882 1.25189 31.3785L5.99005 31.3731L8.05424 24.8455V17.515H4.0074V17.9794C4.29545 17.9661 4.85736 17.9404 4.92029 18.2905C4.98853 18.6716 4.97435 19.7272 4.93624 20.1357C4.79621 21.6487 2.63541 21.8764 2.11603 20.5674C1.97777 20.2191 1.96359 18.8816 2.03184 18.4925C2.15503 17.7924 2.9465 18.0458 3.01208 17.9803C3.05019 17.9422 2.98106 17.0957 3.02538 16.899C3.04488 16.8103 3.05285 16.5205 3.31077 16.5205H8.05424V9.42215H4.0074V9.95305C4.40003 9.95039 4.89281 9.88391 4.93713 10.382C4.95485 11.0396 5.0745 12.2397 4.67124 12.7724C3.80444 13.9299 2.12313 13.3821 2.01411 11.9791C1.98486 11.6024 2.01588 10.4254 2.15592 10.125C2.25518 9.91228 3.01208 9.99825 3.01208 9.95305V8.79199C3.01208 8.66702 3.34533 8.38607 3.50753 8.42506L8.17921 8.41975L10.1734 0.891517C10.2842 0.630059 10.4641 0.549406 10.7388 0.528134C11.891 0.436846 13.1602 0.60347 14.3266 0.529021C14.8912 0.574222 14.9417 1.31605 15.0693 1.77693C15.6791 3.98293 16.1896 6.21906 16.8197 8.41886L21.5579 8.42506C21.8167 8.42595 21.9878 8.59967 21.9878 8.72463V9.95216C22.4531 10.0053 22.9281 9.76869 22.9857 10.6461C23.0212 11.0742 23.0301 12.0456 22.9007 12.4249C22.4522 13.7429 20.3073 13.5798 20.0787 12.2264C20.0166 11.8586 20.0255 10.9023 20.0627 10.5158C20.1194 9.93177 20.4881 9.93621 20.9924 9.95305V9.42215H16.9456V16.3885H21.6891C22.1446 16.3885 21.9275 17.7879 21.9878 17.8482C22.0533 17.9138 22.8448 17.6612 22.968 18.3605C23.0371 18.7505 23.023 20.0294 22.9015 20.3866C22.4407 21.7417 20.2152 21.537 20.0636 20.071C20.0237 19.6828 20.0202 18.7363 20.0796 18.3605C20.162 17.8367 20.5298 17.826 20.9933 17.8482V17.3838H16.9465V24.8473L19.0107 31.3749L23.7488 31.3802C23.9988 31.39 24.2053 31.569 24.2416 31.8163C24.3063 32.2577 24.2939 33.5437 24.2469 34.0046C24.2195 34.2687 24.1007 34.4885 23.9128 34.5H1.08793V34.4982ZM9.1825 8.42595H15.8829L13.9517 1.53408C13.029 1.56245 12.0541 1.47027 11.1368 1.52256C10.9994 1.53054 10.9826 1.71312 10.94 1.85758C10.3019 4.0299 9.80557 6.25009 9.1825 8.42595ZM15.2856 9.42038H9.71251L12.5247 12.2034L15.2856 9.42038ZM9.04956 15.7229L11.8325 12.845L9.04956 10.0842V15.7237V15.7229ZM16.015 15.7229V10.0833L13.232 12.8956L16.015 15.7229ZM3.94093 10.8801H3.01208C3.01208 10.8801 2.93586 11.7496 3.01208 12.0412C3.05817 12.2175 3.24164 12.37 3.32318 12.3939C4.15098 12.6439 3.99676 11.341 3.94093 10.8801ZM21.986 10.8801H21.0483C21.0483 11.3428 20.8427 12.5118 21.6749 12.3939C21.7591 12.3824 21.986 12.2486 21.986 12.0412V10.8801ZM15.2856 16.3867L12.4716 13.6028L9.77898 16.3867H15.2856ZM15.2856 17.382H9.71251L12.5247 20.165L15.2856 17.382ZM9.04956 23.618L11.8325 20.8058L9.04956 18.045V23.618ZM16.015 23.618V18.045L13.232 20.8572L16.015 23.618ZM21.986 18.8417H21.0306C21.0288 18.9933 20.9738 19.8645 21.1201 20.1393C21.2557 20.3945 21.986 20.2722 21.986 20.0028V18.8417ZM3.95865 18.9738H3.00322C3.00322 18.9738 2.966 19.83 3.01208 20.1349C3.03779 20.3077 3.18757 20.4628 3.32406 20.4849C4.17314 20.6188 3.9879 19.3514 3.95865 18.9738ZM15.2856 24.2819L12.4716 21.498L9.77898 24.2819H15.2856ZM18.0056 31.3802L16.0859 25.3055H8.91218L6.99246 31.3802H18.0056ZM23.2472 32.3091H1.75177V33.5029H23.2472V32.3091Z"
                  fill="#5E5E5E"
                />
              </svg>
              계통 판매량
            </HeaderTitle>
            <HeaderContent>
              <HeaderContentGrid>
                <Unit3>
                  <Unit3Title>정읍</Unit3Title>
                  {Number(정읍Data?.genSum) - Number(정읍Data?.usgSum) > 0
                    ? (Number(정읍Data?.genSum) - Number(정읍Data?.usgSum))
                        .toFixed(0)
                        .toLocaleString()
                    : 0}{" "}
                  MWh
                </Unit3>
                <Unit3>
                  <Unit3Title>보령</Unit3Title>
                  {Number(보령Data?.genSum) - Number(보령Data?.usgSum) > 0
                    ? (Number(보령Data?.genSum) - Number(보령Data?.usgSum))
                        .toFixed(0)
                        .toLocaleString()
                    : 0}{" "}
                  MWh
                </Unit3>
              </HeaderContentGrid>
              <HeaderContentGrid>
                <Unit3>
                  <Unit3Title>대전</Unit3Title>
                  {Number(대전Data?.genSum) - Number(대전Data?.usgSum) > 0
                    ? (Number(대전Data?.genSum) - Number(대전Data?.usgSum))
                        .toFixed(0)
                        .toLocaleString()
                    : 0}{" "}
                  MWh
                </Unit3>
                <Unit3>
                  <Unit3Title>여수</Unit3Title>
                  {Number(여수Data?.genSum) - Number(여수Data?.usgSum) > 0
                    ? (Number(여수Data?.genSum) - Number(여수Data?.usgSum))
                        .toFixed(0)
                        .toLocaleString()
                    : 0}{" "}
                  MWh
                </Unit3>
              </HeaderContentGrid>
            </HeaderContent>
          </Header>
          <Page1Table
            대전Data={대전Data}
            보령Data={보령Data}
            여수Data={여수Data}
            정읍Data={정읍Data}
          />
        </Frame2>
      </Content>
      <PageArrowWrapper></PageArrowWrapper>
    </Wrapper>
  )
}

export default Page1
